<template>
  <div>
    <b-row>
      <b-col>
        <c-input
          inputType="text"
          inputId="FirstName"
          lableText="First Name"
          v-model="userinfo.first"
          class="mt-0"
        />
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <c-input
          inputType="text"
          inputId="LastName"
          lableText="Last Name"
          v-model="userinfo.last"
          class="mt-0"
        />
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col>
        <c-input
          inputType="text"
          inputId="Email"
          lableText="Email"
          v-model="userinfo.email"
          class="mt-0"
        />
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <c-tel-input v-model="userinfo.phone" class="m-0" />
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <p>Profile Photo :</p>
        <single-image
          height="150px"
          width="130px"
          @change="(d) => uploadImage('profilePhoto', d)"
          :id="'profilePhoto'"
          :url="userInfo.profilePhoto"
          label="Browse Profile Photo"
        ></single-image>
      </b-col>
      <b-col md="4">
        <label>Marital Status :</label>
        <eb-select
          type="text"
          v-model="userinfo.maritalStatus"
          :options="['Single', 'Married']"
          label="label"
          placeholder="Select Marital Status"
        ></eb-select>
      </b-col>
      <b-col md="5">
        <label>Education :</label>
        <c-input
          inputType="text"
          inputId="Education"
          lableText="Enter Education"
          v-model="userinfo.education"
          class="mt-0"
        ></c-input>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <b-row>
          <b-col md="6">
            <label>DOB :</label>
            <b-input id="activation-date" type="date" v-model="userinfo.dob"></b-input>
          </b-col>
          <b-col md="6">
            <label>Gender:</label>
            <eb-select
              type="text"
              v-model="userinfo.gender"
              :options="['Female', 'Male', 'Others']"
              label="label"
              placeholder="Select Gender"
            ></eb-select>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <b-row>
          <b-col md="9">
            <c-input
              inputType="number"
              inputId="Experience"
              lableText="Working Experience"
              v-model="userinfo.value"
              class="mt-0"
            />
          </b-col>
          <b-col md="3">
            <eb-select
              type="text"
              v-model="userinfo.uom"
              :options="['Days', 'Months', 'Years']"
              label="label"
              placeholder="UOM"
            ></eb-select>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <label>About Me (Optional):</label>
        <textarea
          id="AboutMe"
          rows="3"
          cols="50"
          style="border: 1px solid grey"
          inputType="text"
          v-model="userinfo.aboutMe"
        ></textarea>
      </b-col>
    </b-row>
    <slot name="footer-button" :data="userinfo"></slot>
  </div>
</template>
<script>
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";
import SingleImage from "../../components/Common/Image.vue";
import Vue from "vue";
export default {
  name: "userinfoStepper",
  props: {
    userInfo: {
      type: Object,
      required: false,
      default: () => ({
        firstName: "",
        lastName: "",
        value: "",
        uom: "",
        dob: "",
        gender: "",
        profilePhoto: "",
        authentication: {
          email: "",
          phone: "",
        },
        maritalStatus: "",
        education: "",
        aboutMe: "",
      }),
    },
  },
  data() {
    return {
      userinfo: {
        first: "",
        last: "",
        email: "",
        phone: "",
        value: "",
        uom: "",
        gender: "",
        dob: "",
        profilePhoto: "",
        maritalStatus: "",
        education: "",
        aboutMe: "",
      },
    };
  },
  components: {
    cInput,
    cTelInput,
    ebSelect,
    SingleImage,
  },
  methods: {
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    async uploadImage(path, image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: ["agent", "profilePhoto"],
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          this.clearCustomToast();
          this.userinfo[path] = res.data.fileUrl;
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
  },
  mounted() {
    setTimeout(() => {
      this.userinfo = {
        first: this.userInfo.firstName || "",
        last: this.userInfo.lastName || "",
        email: this.userInfo.authentication.email || "",
        phone: this.userInfo.authentication.phone || "",
        dob: this.userInfo.dob || "",
        value: this.userInfo.value || "",
        uom: this.userInfo.uom || "",
        gender: this.userInfo.gender || "",
        profilePhoto: this.userInfo.profilePhoto || "",
        maritalStatus: this.userInfo.maritalStatus || "",
        education: this.userInfo.education || "",
        aboutMe: this.userInfo.aboutMe || "",
      };
    }, 200);
  },
};
</script>
<style scoped>
.location-search {
  border-radius: 0rem;
  color: rgb(0, 0, 0);
  box-shadow: none !important;
  font-family: 'Lato';
  height: 39px !important;
  border: 1px solid #dee2e6;
  padding-left: 10px;
  width: 100%;
  font-size: small;
}

[btn-color="primary"] {
  height: 41px;
  background-color: #727cf5;
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: 'Lato';
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: 'Lato';
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: #727cf5;
  color: white;
}
</style>
<style>
.custom-file-label {
  border-radius: 0px !important;
  border: 1px solid #dee2e6 !important;
  color: #dee2e6 !important;
}
</style>
